import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import useStyles from './styles';

function ReviewContactDetails(props) {
  const { formValues } = props;
  const classes = useStyles();
  const { leadName, leadCompany, leadEmail, leadPhone } = formValues;
  return (
    <Grid item xs={12} sm={6}>
    <Typography variant="h6" gutterBottom className={classes.title}>
      Contact Details
    </Typography> 
    <Typography gutterBottom>{`${leadName}`}</Typography>
    { leadCompany ? <Typography gutterBottom>{`${leadCompany}`}</Typography> : null }
    <Typography gutterBottom>{`${leadEmail}`}</Typography>
    <Typography gutterBottom>{`${leadPhone}`}</Typography>
    </Grid>
  );
}

export default ReviewContactDetails;
